export class NGSSample {
	sampleBarcode: string;
	sampleNameCustomer: string;
	orderComment: string;
	sampleSource: string;
	libraryType: string;
	orderNumber: string;
	customerName: string;
	gxp: boolean;
	express: boolean;
	extraction: boolean;
	sampleCountInOrder: number;
	sampleCountInContainer: number;
	batchId: string;
	wellPosition: string;
	stepComment: string;
    savedSample: boolean = false;
    selectedForRemove: boolean = false;
	version: number;
	creationDate: Date;
	sampleName:string;
	lastModifiedDate: Date;
	sampleComment: string;
}